import React from 'react'
import moment from 'moment'
const Notification = ({name,message, min, color,time}) => {
    return (
        <>
            <span className="d-flex mr-3">
                   <span className="circle-style mr-3 bg1">
                        {name[0].toUpperCase()}
                   </span>
            </span>
            <div className="media-body">
                <h5 className="mt-0 noti-heading mb-0"><span>{name},</span> {message}.</h5>
                <p className="noti-date mb-0">{moment(time).fromNow()}</p>
            </div>
        </>
           )
}

export default Notification
